import React from "react";
import styles from "./KeyFeatures.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowTrendUp, faBolt, faChartLine, faMobileAlt, faPalette, faSearch} from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";

const keyFeatures: React.FC = () => {
    // const { t } = useTranslation();

    const keyFeatures = [
        {
            title: "Fast Loading Performance",
            icon: faBolt,
            description: "Loads quickly to keep visitors engaged and reduce bounce rates."
        },
        {
            title: "Mobile-Responsive Design",
            icon: faMobileAlt,
            description: "Looks and works perfectly on every device — phone, tablet, or desktop."
        },
        {
            title: "SEO-Friendly Structure",
            icon: faSearch,
            description: "Built with clean, optimized code that helps search engines understand and rank your site."
        },
        {
            title: "Scalable for Growth",
            icon: faArrowTrendUp,
            description: "Built to grow with your business and handle increasing needs over time."
        },
        {
            title: "Brand Reflection",
            icon: faPalette,
            description: "A design that communicates your identity and builds trust with customers."
        },
        {
            title: "Smart, Conversion-Driven User Experience",
            icon: faChartLine,
            description: "Designed to guide visitors toward action with clear navigation and high-impact layouts."
        }
    ];

    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className="sectionTitle">
                    Key Features Included in Every Project
                </h1>
            </LazyText>
            {/* YOUR GRID — UNTOUCHED */}
            {/*<LazyText>*/}
            <div className={styles.gridContainer}>
                {keyFeatures.map((feature, index) => (
                    <div className={styles.card}>
                        <div className={styles.card_title}>
                            {feature.title}
                        </div>
                        <div className={styles.icon_container}>
                            <FontAwesomeIcon icon={feature.icon}/>
                        </div>
                        <div className={styles.content}>
                            <p>
                                {feature.description}
                            </p>
                        </div>
                    </div>

                ))}
            </div>
            {/*</LazyText>*/}
        </section>
    );
};

export default keyFeatures;
